import { categories } from './Navbar';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100 rounded-2xl mx-4 md:mx-6 mb-6 overflow-hidden">
      <div className="px-8 md:px-14 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 mb-3">
              Stay Updated
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6">
              Get the latest sourcing tips, product updates, and exclusive deals delivered straight to your inbox.
            </p>
            <form
              action="https://readdy.ai/api/form/d90dlao4jh3v1cgkslo0"
              method="POST"
              data-readdy-form="true"
              className="relative"
            >
              <input
                type="text"
                name="website_alt"
                className="form-website-alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your email address"
                  className="flex-1 bg-transparent border-0 border-b border-foreground-600 text-background-50 text-sm py-2.5 px-1 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 text-foreground-900 text-sm font-medium cursor-pointer hover:bg-background-100 transition-colors duration-200 whitespace-nowrap"
                >
                  Subscribe
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </button>
              </div>
            </form>
          </div>

          <div>
            <h4 className="text-background-300 text-xs font-semibold uppercase tracking-widest mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors duration-150 underline decoration-foreground-600/30 underline-offset-4"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-300 text-xs font-semibold uppercase tracking-widest mb-4">
              Contact
            </h4>
            <div className="space-y-3 text-sm text-foreground-400 mb-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block hover:text-background-50 transition-colors duration-150"
              >
                kaspreadsheet.com
              </a>
              <a
                href="mailto:support@kaspreadsheet.com"
                className="block hover:text-background-50 transition-colors duration-150"
              >
                support@kaspreadsheet.com
              </a>
            </div>
            <h4 className="text-background-300 text-xs font-semibold uppercase tracking-widest mb-4">
              Office
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              Global Sourcing Network<br />
              Available Worldwide
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-500">
          <div className="flex items-center gap-5">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-background-50 transition-colors duration-150 underline decoration-foreground-600/30 underline-offset-4"
            >
              Main Website
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-background-50 transition-colors duration-150 underline decoration-foreground-600/30 underline-offset-4"
            >
              Products
            </a>
          </div>
          <p>&copy; {new Date().getFullYear()} itaobuy.skin. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-background-50 transition-colors duration-150 underline decoration-foreground-600/30 underline-offset-4"
            >
              Privacy Policy
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-background-50 transition-colors duration-150 underline decoration-foreground-600/30 underline-offset-4"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}